import React, { useState, useEffect } from "react";
import useClock from "./../useClock"; // Import custom hook
import "./CompetitiveClockDisplay.css";
import "boxicons/css/boxicons.min.css";

const CompetitiveClockDisplay = ({ targetTime, timer }) => {
  // Call useClock without the timer parameter
  const {
    hours,
    minutes,
    seconds,
    ampm,
    day,
    month,
    year,
    hourAngle,
    minuteAngle,
    secondAngle,
  } = useClock(targetTime);

  // Compute the countdown angle live:
  // At timer = 30, angle should be 180deg (6 o'clock)
  // At timer = 0, angle should be 0deg (12 o'clock)
  const computedCountdownAngle = (timer / 30) * 180;

  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("selected-theme") === "dark"
  );

  useEffect(() => {
    document.body.classList.toggle("dark-theme", isDarkMode);
    localStorage.setItem("selected-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return (
    <section className="clock container">
      <div className="clock__content grid">
        <div className="clock__circle">
          <span className="clock__twelve"></span>
          <span className="clock__three"></span>
          <span className="clock__six"></span>
          <span className="clock__nine"></span>
          <span className="clock__one"></span>
          <span className="clock__two"></span>
          <span className="clock__four"></span>
          <span className="clock__five"></span>
          <span className="clock__seven"></span>
          <span className="clock__eight"></span>
          <span className="clock__ten"></span>
          <span className="clock__eleven"></span>

          {/* Render 60 minute ticks dynamically */}
          {/* <div className="clock__minute__ticks-container">
            {Array.from({ length: 60 }).map((_, i) => (
              <span
                key={i}
                className="clock__minute__tick"
                style={{
                  transform: `rotate(${
                    i * 6
                  }deg) translateY(calc(-90px * var(--clock-scale)))`,
                }}
              ></span>
            ))}
          </div> */}

          {/* <div className="clock__numbers">
            <span className="clock__number clock__twelve-number">12</span>
            <span className="clock__number clock__three-number">3</span>
            <span className="clock__number clock__six-number">6</span>
            <span className="clock__number clock__nine-number">9</span>
          </div> */}

          {/* Countdown hand overlay */}
          <div className="clock__rounder"></div>
          <div
            className="clock__hour"
            style={{ transform: `rotateZ(${hourAngle}deg)` }}
          ></div>
          <div
            className="clock__minutes"
            style={{ transform: `rotateZ(${minuteAngle}deg)` }}
          ></div>
          <div
            className="clock__countdown"
            style={{ transform: `rotateZ(${computedCountdownAngle}deg)` }}
          ></div>
          {/* DEBUG DEBUGGER DISPLAY */}
          {/* <div className="inClockDisplay">
            <span className="hour">{hours}:</span>
            <span className="minutes">{minutes}</span>
          </div> */}

          {/* 
          <div
            className="clock__theme"
            onClick={() => setIsDarkMode(!isDarkMode)}
          >
            <i className={`bx ${isDarkMode ? "bxs-sun" : "bxs-moon"}`}></i>
          </div> */}
        </div>

        {/* Clock Text */}
        {/* <div className="clock__text"> */}
        {/* <div className="clock__text-debug">
            DEBUG: {hours}:{minutes}
          </div> */}

        {/* <div className="clock__text-ampm-debug">{ampm}</div>
        </div>
        <div>
          <div className="clock__text">
            <div className="clock__text-hour">{hours}:</div>
            <div className="clock__text-minutes">{minutes}</div>
            <div className="clock__text-ampm">{ampm}</div>
          </div> */}

        {/* <div className="clock__date">
            <span>{day}</span> <span>{month},</span> <span>{year}</span>
          </div> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default CompetitiveClockDisplay;
